import {AddCardForm} from 'organization/Billing/AddCardForm'
import {PaymentMethods} from 'organization/Billing/PaymentMethods'
import {useOrganizationBilling} from 'organization/Billing/Providers/OrganizationBillingProvider'
import {useI18n} from 'i18n/I18nContext'
import {Loader} from 'organization/theme/Loader'
import React, {useEffect, useState} from 'react'

export function Pay() {
  const {t} = useI18n()
  const {paymentMethods, getPaymentMethods, selectPaymentMethod, loading} =
    useOrganizationBilling()
  const [showAddForm, setShowAddForm] = useState<boolean>(false)

  useEffect(() => {
    getPaymentMethods()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      {paymentMethods.length > 0 && (
        <PaymentMethods
          onSelect={selectPaymentMethod}
          selectLabel={t('orgBilling.selectPayment')}
        />
      )}
      {(showAddForm || paymentMethods.length <= 0) && <AddCardForm />}
      {!showAddForm && paymentMethods.length > 0 && (
        <button
          className="element__btn red-bg w-100 text-center mt-15"
          onClick={() => {
            setShowAddForm(true)
          }}
        >
          {t('orgBilling.addAnotherPaymentMethod')}{' '}
          <i className="fa-regular fa-angle-right"></i>
        </button>
      )}
    </div>
  )
}
